var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my_clazz"},[_c('van-nav-bar',{attrs:{"title":"我的班级","left-text":"","right-text":"","left-arrow":""},on:{"click-left":_vm.back}}),_vm._l((_vm.joinList),function(item,index){return _c('in-clazz-panel',{key:index,attrs:{"clazz":item.clazz}})}),(_vm.noList)?_c('div',{staticClass:"empty"},[_vm._v("暂无班级")]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }